import StringHelper from './string'

export default {
  calculateWidth(schema, min = 10, max = 50) {
    let widthArr = []
    for (let each of schema) {
      let columnLen = each.column.length
      let width = columnLen ? columnLen : 0
      if (width < min) {
        width = min
      }
      if (width > max) {
        width = max
      }
      widthArr.push(width)
    }
    return widthArr
  },

  addWidthToSchema(schema, widthArr) {
    for (let i = 0; i < schema.length; i++) {
      schema[i].width = widthArr[i]
    }
    return schema
  }
}
